var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15.1606V30.1606H41.25M52.5 30.1606C52.5 33.1154 51.918 36.0412 50.7873 38.771C49.6566 41.5008 47.9992 43.9812 45.9099 46.0705C43.8206 48.1599 41.3402 49.8172 38.6104 50.9479C35.8806 52.0787 32.9547 52.6606 30 52.6606C27.0453 52.6606 24.1194 52.0787 21.3896 50.9479C18.6598 49.8172 16.1794 48.1599 14.0901 46.0705C12.0008 43.9812 10.3434 41.5008 9.21271 38.771C8.08198 36.0412 7.5 33.1154 7.5 30.1606C7.5 24.1933 9.87053 18.4703 14.0901 14.2507C18.3097 10.0312 24.0326 7.66064 30 7.66064C35.9674 7.66064 41.6903 10.0312 45.9099 14.2507C50.1295 18.4703 52.5 24.1933 52.5 30.1606Z",
    stroke: "#60A5FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.496baefc38541f99d2614670d870305c.svg";
export { ForwardRef as ReactComponent };